import React from "react";

const MedicalRecords = () => {
  return (
    <div>
      <h1>MedicalRecords</h1>
    </div>
  );
};

export default MedicalRecords;
